module.exports = __webpack_public_path__ + "static/media/marcelo.583bb2cc.jpg";